export const capitalize = (text?: string): string | undefined =>
  text && `${text.charAt(0).toUpperCase()}${text.slice(1)}`;
